import { ROSTER_DAILY_CONFIG } from '../roster-daily-config';
import { Text } from 'common-components/typography';
import React from 'react';
import _ from 'lodash';
import { IRosterShift } from '../../types';
import { Calendar } from '@good/icons';
import { Avatar } from '@good/ui/core';

interface OpenShiftsContentRowProps {
  unassignedShifts?: IRosterShift[][];
}

const { TIMELINE_ROW_HEIGHT } = ROSTER_DAILY_CONFIG;

export function OpenShiftsSideColumn({ unassignedShifts = [] }: OpenShiftsContentRowProps) {
  const rowHeight = _.size(unassignedShifts) * TIMELINE_ROW_HEIGHT;
  const shiftsCount = _.chain(unassignedShifts).flatten().size().value();

  return (
    <div
      className='bg-quaternary pv-medium pl-x-large pr-medium flex-row justify-between bordered-right bordered-bottom'
      style={{ height: rowHeight }}
    >
      <div className='flex-row align-center'>
        <Avatar radius='md' mr='sm'>
          <Calendar />
        </Avatar>
        <div className='line-height-135 flex-column'>
          <Text lineHeight={120}>Unassigned shifts</Text>
          <div className='line-height-120 flex-row align-center'>
            <Text size='regular' color='secondary' lineHeight={120}>
              {shiftsCount} unassigned
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
